module.exports = __webpack_public_path__ + "img/couples-029.5fec9068.jpg";